import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

/**
 * Espelho local dos colaboradores da view de RH do TOTVS/Protheus
 * ([DBAI].[dbo].[vw_TOTVS_DADOS_MESTRES_RH]). Um job (apps/api ·
 * services/totvs-sync.ts) faz UPSERT periódico por matrícula e remove os
 * ausentes (demitidos). O onboarding consulta ESTA tabela — instantâneo — em
 * vez da view pesada do SQL Server.
 *
 * CPF é deliberadamente omitido (PII fora do app). `emailPessoal` é o e-mail
 * do RH (pessoal), NUNCA usado como identidade de login — o login corporativo
 * vem pelo Clerk.
 */
export const totvsCollaborators = pgTable(
  'totvs_collaborators',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    matricula: text('matricula').notNull().unique(),
    nome: text('nome').notNull(),
    emailPessoal: text('email_pessoal'),
    funcao: text('funcao'),
    codFilial: text('cod_filial'),
    filial: text('filial'),
    codSecao: text('cod_secao'),
    setorNome: text('setor_nome'),
    situacao: text('situacao'),
    // momento do último pull bem-sucedido da view que tocou este registro —
    // marcador usado pelo sync para remover os ausentes (demissões).
    syncedAt: timestamp('synced_at', { withTimezone: true }).notNull().defaultNow(),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp('updated_at', { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [
    index('totvs_collaborators_cod_filial_idx').on(t.codFilial),
    index('totvs_collaborators_situacao_idx').on(t.situacao),
  ],
);

export type TotvsCollaboratorRecord = typeof totvsCollaborators.$inferSelect;
export type NewTotvsCollaborator = typeof totvsCollaborators.$inferInsert;
